<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" width="500">
            <template v-slot:activator="{ props }">
                <v-btn color="teal-lighten-2" class="mr-6 mb-4 mt-4" v-bind="props">
                    Agregar Usuario
                </v-btn>
            </template>

            <v-card>
                <v-card-title>
                    <span class="text-h5">Usuario Nuevo</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-row>
                                    <v-col cols="10">
                                        <v-text-field v-model="carnet" color="cyan-darken-2" label="Numero de Carnet"
                                            :rules="[() => !!carnet || 'Este campo es obligatorio']"
                                            :error-messages="getValidationErrors('carnet')"></v-text-field>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-btn icon="mdi-magnify" size="compact" color="orange-darken-3" variant="outlined"
                                            class="pa-3" @click="buscarNombre()"></v-btn>
                                    </v-col>
                                </v-row>
                                <v-text-field v-model="localNombreCompleto" color="cyan-darken-2"
                                    label="Nombre"></v-text-field>
                                <v-text-field v-model="correoElectronico" color="cyan-darken-2" label="Correo Electronico"
                                    type="mail"></v-text-field>
                                <v-text-field v-model="contrasena" color="cyan-darken-2" label="Contraseña"
                                    type="password"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                    <small>*indica campo requerido</small>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue-darken-1" variant="text" @click="dialog = false">
                        Salir
                    </v-btn>
                    <v-btn color="blue-darken-1" variant="text" @click="guardarUsuario">
                        Guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
  
<script>
import { defineComponent } from 'vue';
import Busqueda from "@/services/Personal";
import Usuario from "@/services/Usuario";

export default defineComponent({
    name: 'AdminFormPage',
    props: {
        dialogoAbierto: Boolean,
        dialog_parent: Object,
        registro_parent: Object,
        formTitleParent: Object,
        errors_validate_parent: Object,
    },
    data() {
        return {
            dialogoAbiertoLocal: this.dialogoAbierto,
            dialog: false,
            optionstipoarma: [],
            optionsprocedencia: [],
            optionsclasificacion: [],
            optionscalibre: [],
            item_busqueda: [],
            carnet: '',
            localNombreCompleto: '',
            correoElectronico: '',
            contrasena: '',
        };
    },
    watch: {
        dialogoAbierto(newVal) {
            this.dialogoAbiertoLocal = newVal;
        },
    },
    methods: {
        getValidationErrors(fieldName) {
            const errors = {
                carnet: 'Este campo es obligatorio.',
                // Agrega más mensajes según tus campos
            };

            return errors[fieldName] || '';
        },

        async buscarNombre() {
            try {
                const numeroCarnet = this.carnet;
                const busqueda = new Busqueda();
                const resultadoBusqueda = await busqueda.busquedaporci(numeroCarnet);

                if (
                    resultadoBusqueda &&
                    resultadoBusqueda.status &&
                    resultadoBusqueda.records &&
                    resultadoBusqueda.records.data &&
                    resultadoBusqueda.records.data.nombre
                ) {
                    this.localNombreCompleto = resultadoBusqueda.records.data.nombre;
                } else {
                    alert(
                        'Carnet no encontrado en la base de datos o no hay un nombre disponible en la respuesta'
                    );
                }
            } catch (error) {
                console.error(error);
            }
        },
        async guardarUsuario() {
            try {
                // Crear un objeto con los datos a enviar al backend
                const usuario = {
                    nombres: this.localNombreCompleto,
                    correo: this.correoElectronico,
                    password: this.contrasena,
                    status: true, // Puedes ajustar este valor según tus necesidades
                    roles: 1, // Puedes ajustar este valor según tus necesidades
                    carnet: this.carnet,
                };

                // Instanciar el servicio de usuario
                const usuarioService = new Usuario();

                // Llamar al método para crear usuario
                const response = await usuarioService.crearUsuario(usuario);
                if (response.message === 'Usuario creado exitosamente') {
                    this.dialog = false;
                    window.location.reload();
                } else {
                    alert('Error al crear usuario. Por favor, inténtelo de nuevo.');
                }
                this.dialogoAbiertoLocal = false;
                console.log('Usuario creado exitosamente', response);
            } catch (error) {
                console.error('Error al crear usuario', error);
                alert('Error al crear usuario. Por favor, inténtelo de nuevo.');
            }
        },
    },
});
</script>